<template>
<div class="box p-0">
	<div class="integration-item">
		<section-warehouse-header />
		<div class="integration-accounts">
			<div class="integration-account">
				<div class="wrapper">
					<div class="container-fluid p-0">
						<div class="row">
							<div class="col-12">
								<section-warehouse-body-setting
								:enabled="configuration.enabled"
								@set="value => configuration.enabled = value"
							/>
							</div>
							<div class="col-12">
								<section-warehouse-body-filter :select="configuration.shipping_type" @change="chooseOption" />
							</div>
							<div class="col-12 mt-5">
								<div class="form-group text-right">
									<button
										type="button"
										class="btn btn-primary btn-icon"
										@click="submit"
									>
										<i class="material-icons">save</i>
										<span>{{ $t("Save") }}</span>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="integration-account">
				<div class="wrapper">
					<div class="container-fluid p-0">
						<div class="row">
							<div class="col-12">
								<section-warehouse-body-content  @show-notify="showNotify" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { mapActions } from 'vuex';
import SectionWarehouseHeader from '@/components/setting/Warehouse/section/Header.vue';
import SectionWarehouseBodySetting from '@/components/setting/Warehouse/section/body/Setting.vue';
import SectionWarehouseBodyFilter from '@/components/setting/Warehouse/section/body/Filter.vue';
import SectionWarehouseBodyContent from '@/components/setting/Warehouse/section/body/Content.vue';
import userApi from '@/api/user';

export default {
	name: 'SettingWarehouseContent',
	components: {
		SectionWarehouseHeader,
		SectionWarehouseBodySetting,
		SectionWarehouseBodyFilter,
		SectionWarehouseBodyContent,
	},
	data: () => ({
		selectWarehouse: '',
		configuration: {
			enabled: false,
			shipping_type: 'nearest',
		},
	}),
	computed: {
	},
	created() {
		this.fetchSettingUserConfiguration();
	},
	methods: {
		...mapActions({
			settingUserConfiguration: 'warehouse/settingUserConfiguration',
			// fetchSettingUserConfiguration: 'warehouse/fetchSettingUserConfiguration',
		}),
		chooseOption(key) {
			this.configuration.shipping_type = key;
		},
		/**
		 * Set Warehouse
		 *
		 * @param {String} key
		 * @returns {String} selectWarehouse
		 */
		fetchSettingUserConfiguration() {
			const callback = (responses) => {
				const warehouseSetting = responses.data.filter(item => item.key === 'warehouse').map(curr => curr.value);
				this.configuration = {
					enabled: !!warehouseSetting[0]?.enabled,
					shipping_type: warehouseSetting[0]?.shipping_type,
				};
			};
			const err = (e) => {
				console.log(e);
			};
			userApi.getUserSetting({}, callback, err);
		},
		/**
		 * Submit User
		 *
		 * @this {Array} params
		 * @this {Function} showNotify
		 * @this {Function} settingUserConfiguration
		 */
		submit() {
			const params = [
				{
					key: 'warehouse',
					value: {
						enabled: this.configuration?.enabled ?? false,
						shipping_type: this.configuration?.shipping_type ?? 'nearest',
					},
				},
			];
			this.showNotify(this.$t('Setting Configuration'), this.$t('Warehouse settings changed successfully'), 'success');
			this.settingUserConfiguration(JSON.stringify(params));
		},

		/**
		 *  Show Notify
		 *
		 * @param {Sring} title
		 * @param {Sring} text
		 * @param {Sring} type
		 */
		showNotify(title, text, type) {
			this.$notify({
				group: 'app',
				title,
				text,
				type,
			});
		},
	},
};
</script>

<style lang="scss">
.page-content-warehouse {
	&__header {
		// padding: 1em;
		background-color: #9cdce2;
		border-radius: 6px;
		&__wrapper {
			display: flex;
			margin: 0 auto;
			max-width: 1500px;
			align-items: center;
			justify-content: space-between;
		}
	}
	&__body {
		padding: 32px 245px;
		background-color: #ffff;
		&--setting {
			padding: 20px 10px;
		}
		&--filter {
			padding: 15px 10px;
		}
		&--content {
			padding: 15px 10px;
			.header {
				margin: 0 0 20px 0;
			}
		}
	}
}

@media (max-width: 756px) {
	.page-content-warehouse {
		&__body {
			padding: 0;
			&--content {
				padding: 15px 50px;
				.header {
					.form-control {
						width: 100%;
					}
				}
			}
		}
	}
}
</style>
